import {
    ROOT,
    ACCOUNT_PROFILE_GET_INFO,
    ACCOUNT_PROFILE_UPDATE_INFO,
    ACCOUNT_PROFILE_UPDATE_PASSWORD,
    ACCOUNT_PROFILE_UPDATE_AVATAR,
    ACCOUNT_PROFILE_DELETE_AVATAR,
    DASHBOARD_CONFIRM_HOTEL_INFO,
    DASHBOARD_INFO_STATUS,
    ACCOUNT_PROFILE_RESET_PASSWORD
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

// const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
// const authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};

function getProfile() {
    return fetch(ROOT + ACCOUNT_PROFILE_GET_INFO, requestOptions.get())
        .then(handleResponse);
}

function updateInfo(data) {
    return fetch(ROOT + ACCOUNT_PROFILE_UPDATE_INFO, requestOptions.post(data))
        .then(handleResponse);
}

function updatePassword(data) {
    return fetch(ROOT + ACCOUNT_PROFILE_UPDATE_PASSWORD, requestOptions.post(data))
        .then(handleResponse);
}

function resetPassword(data) {
    return fetch(ROOT + ACCOUNT_PROFILE_RESET_PASSWORD, requestOptions.post(data))
        .then(handleResponse);
}

function updateAvatar(formData) {
    let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    let authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};
    return fetch(ROOT + ACCOUNT_PROFILE_UPDATE_AVATAR, {
        method: 'POST',
        body: formData,
        headers: {
            Authorization: authHeader.Authorization
        }
    }).then(handleResponse);
}

function deleteAvatar() {
    return fetch(ROOT + ACCOUNT_PROFILE_DELETE_AVATAR, requestOptions.get())
        .then(handleResponse);
}

function confirmHotelInfo() {
    return fetch(ROOT + DASHBOARD_CONFIRM_HOTEL_INFO, requestOptions.get())
        .then(handleResponse);
}

function getInfoStatus() {
    return fetch(ROOT + DASHBOARD_INFO_STATUS, requestOptions.get())
        .then(handleResponse);
}

export const service = {
    getProfile,
    updateInfo,
    updatePassword,
    updateAvatar,
    deleteAvatar,
    confirmHotelInfo,
    getInfoStatus,
    resetPassword
};